// Hardocding this list at our end since this list is not going to change frequently and
// it is required for short term solution for piloting quick food project.
export const qFoodRestaurantsList: string[] = [
    "611797",
    "648277",
    "648278",
    "648279",
    "648269",
    "646971",
    "646849",
    "648797",
    "648798",
    "648285",
    "648284",
    "648283",
    "646623",
    "611048",
    "611037",
    "648804",
    "648803",
    "608938",
    "648238",
    "648505",
    "611574",
    "615316",
    "615077",
    "553954",
    "611560",
    "611572",
    "611159",
    "612451",
    "611677",
    "612225",
    "612895",
    "612319",
    "610265",
    "610194",
];

export const Q_FOOD_SLA = "15 mins";
export const MIN_ANDROID_VERSION_Q_FOOD = 1051;
export const MIN_IOS_VERSION_Q_FOOD = 425;
